<template lang="pug">
div
  v-tabs(v-model='tab' align-with-title='' )
    v-spacer
    v-tabs-slider(color='primary')
    v-tab(key='upload', v-show="multiple || !files.length && !multiple")
      span Adjuntar
    v-tab(key='archivos', v-if="files.length")
      span {{files.length}} Archivo(s)
  v-tabs-items(v-model='tab')
    v-tab-item(key='adjuntar' :disabled="isMovil" v-show="multiple || !files.length && !multiple")
      //- v-alert.mb-0(dense='' type='error' v-if="$upload.errors(name).length > 0",)
      //-   v-row(align='center')
      //-     v-col.grow
      //-       .d-flex.fd-column
      //-         small.font-size-12(v-for="(e, i) in $upload.errors(name)")
      //-           |  • {{ e.msg }} &nbsp;
      //-           span.font-weight-700 ({{e.file.name}})
      //-     v-col.shrink
      //-       v-btn(color="white primary--text" small) Quitar errores
      v-card.elevation-0.d-flex.jc-center.ai-center.fd-column(
        :height="isMovil ? 'calc(100vh - 118px)' : '500'",
        id="dropzone",
        :class="{'opacity-5' : $upload.dropzone(name).active}",
        @click='select'
      )
        div
          .d-flex.transform-icons(v-if="accept && accept[0] === 'image/*'")
            v-icon.center(:size="modeInsert ? 70 : 100", color="primary", v-if="!$upload.dropzone(name).active") image_search
          .d-flex.transform-icons(v-else)
            v-icon.left(:size="modeInsert ? 40 : 60", color="primary", v-if="!$upload.dropzone(name).active") picture_as_pdf
            v-icon.center(:size="modeInsert ? 40 : 60", color="primary", v-if="!$upload.dropzone(name).active") insert_photo
            v-icon.right(:size="modeInsert ? 40 : 60", color="primary", v-if="!$upload.dropzone(name).active") text_snippet
          v-icon(size="80px", color="primary", v-if="$upload.dropzone(name).active") preview
        v-card-text.text-center
          template(v-if="!isMovil")
            h2.primary--text(v-if="!$upload.dropzone(name).active")
              template(v-if="multiple")
                | Arrastra y suelta tus archivos aquí
              template(v-else)
                | Arrastra y suelta el archivo aquí
            h2.primary--text(v-else)
              template(v-if="multiple")
                | Suelta tus archivos para visualizarlos
              template(v-else)
                | Suelta el archivo para visualizarlo
          template(v-else)
            h2.primary--text Busca tus archivos en tu galeria
          .d-flex.fd-column
            //- small *Subir archivos con un peso no mayor a {{maxSize | mb }} MB*
            small *Subir archivos con un peso no mayor a 10MB*
            small.primary--text.font-weight-700 {{extensionsAllow.toString()}}
    v-tab-item(key='archivos' :disabled="isMovil")
      v-alert.mb-0(dense='' text type='error' v-if="$upload.errors(name).length > 0",)
        .d-flex.fd-column
          small.font-size-11(v-for="(e, i) in $upload.errors(name)")
            |  • {{ e.msg }} &nbsp;
            span.font-weight-700 ({{e.file.name}})
      preview-files(:archivos="files", v-if="files.length" ref="previsualizador", @remove="removeFile" :mode-insert="modeInsert" :is-set-profile="isSetProfile")
  .pa-4.d-flex(v-if="!modeInsert", :class="{'fd-column' : isMovil}")
    v-btn(color="primary", v-if="tab"  :small="!isMovil" :block="isMovil"  @click="volverASeleccionar()", :class="{'mb-3' : isMovil}")
      v-icon.mr-1 arrow_back
      span(v-if="!multiple") Volver a seleccionar
      span(v-else) Seguir seleccionando
    v-spacer(v-if="!isMovil")
    v-btn(color="success", v-if="files.length && tab"  :small="!isMovil" :block="isMovil", @click="sendFilesToSave()", :class="{'mb-3' : isMovil}")
      | {{label}}
    v-btn(color="primary", :small="!isMovil", v-if="isMovil || !tab" :block="isMovil" @click="close()")
      | cancelar
</template>

<script>
  import { notify } from '../util/general'
  import previewFiles from './c_preview_files'
  export default {
    name : 'c_adjuntar_archivos',
    props : {
      modeInsert : {
        type   : Boolean,
        default: false
      },
      multiple : {
        type   : Boolean,
        default: true
      },
      isSetProfile : {
        type   : Boolean,
        default: false
      },
      extensions :{
        type   : Array
      },
      label : {
        type   : String,
        default: 'Enviar archivos'
      },
      accept : {
        type : Array
      }
    },
    components : {
      'preview-files' : previewFiles
    },
    data () {
      return {
        showLista: false,
        files    : [],
        tab      : 0,
        maxSize  : 1024 * 1024 * 30,
        name     : 'adjuntar_archivo_ticket',
        extensionsAllow : this.extensions || ['pdf', 'png', 'jpg', 'jpeg', 'docx', 'xlsx', 'pptx', 'txt', 'html', 'exe', 'doc', 'mp4']
      }
    },
    mounted () {
      var vm = this
      window.addEventListener('paste', vm.uploadClipBoard)
      vm.create()
      vm.$forceUpdate()
    },
    beforeDestroy () {
      var vm = this
      window.removeEventListener('paste', vm.uploadClipBoard);
      vm.$upload.off(vm.name);
    },
    computed : {
      isMovil () {
        var vm = this
        return vm.$vuetify.breakpoint.smAndDown
      }
    },
    filters : {
      mb : function (v) {
        return v / 1024 / 1024
      }
    },
    methods: {
      volverASeleccionar () {
        var vm = this
        if (vm.multiple) {
        } else {
          vm.files = []
        }
        vm.tab = 0
      },
      sendFilesToSave () {
        var vm = this
        if (vm.$upload.errors(vm.name).length) {
          if (vm.$upload.errors(vm.name)[0].code === 'file-max-size') {
            notify(vm, 'error', 'Error',  `El archivo ${vm.$upload.errors(vm.name)[0].file.name} sobrepasa el peso maximo que es 5MB`)
            return
          }
          if (vm.$upload.errors(vm.name)[0].code === 'file-extension') {
            notify(vm, 'error', 'Error',  `El archivo ${vm.$upload.errors(vm.name)[0].file.name} tiene una extencion no permitida`)
            return
          }
        } else vm.$emit('save', vm.files)
        // } else vm.$emit('save', vm.files)
      },
      removeFile (objFile) {
        var vm = this
        if (vm.$upload.errors(vm.name).length) {
          for (var i = 0; i < vm.$upload.errors(vm.name).length; i++) {
            var file = vm.$upload.errors(vm.name)[i];
            if (objFile.name === file.file.name) {
              file.clear()
            }
          }
        }
      },
      create () {
        var vm = this
        vm.$upload.on(vm.name, {
          extensions         : vm.extensionsAllow,
          maxSizePerFile     : vm.maxSize,
          dropzoneId         : 'dropzone',
          startOnSelect      : false,
          multiple           : vm.multiple,
          accept             : vm.accept || ['*'],
          invalidExtensionMsg: 'El archivo no tiene una extencion no permitida',
          maxFileSizeMsg     : 'Máximo de {max}MB por archivo',
          http               : (data) => {
            console.log('IM IN THE HTTP METHOD', data)
          },
          onSelect: (files, res) => {
            for (var i = 0; i < files.length; i++) {
              if (vm.multiple) vm.files.push(files[i])
              else {
                vm.files.push(files[i])
              }
            }
            vm.tab = 1
          },
          onProgress (file, res) {
            console.log('onProgress')
            console.log(file)
            console.log(res)
          },
          onSuccess: (file, res) => {
            console.log('onSuccess')
            console.log(file)
            console.log(res)
            this.file = res.data.data
          },
          onError: (file, res) => {
            console.log('onError')
            console.log(file)
            console.log(res)
            console.log(vm.$upload.errors(vm.name))
          },
          onEnd (files, res) {
            console.log('onEnd')
          }
        })
      },
      select () {
        var vm = this
        vm.$upload.select(vm.name);
      },
      uploadClipBoard (e) {
        var vm = this
        if (e.clipboardData && e.clipboardData.items) {
          var ele = e.clipboardData.items;
          for (var i = 0; i < ele.length; ++i) {
            if (ele[i].kind === 'file' && ele[i].type.indexOf('image/') !== -1) {
              var blob = ele[i].getAsFile();
              vm.files.push(blob)
              vm.tab = 1
            }
          }
        } else {
          return;
        }
      },
      close () {
        var vm = this
        vm.$emit('close')
      },
      getFiles () {
        var vm = this
        return vm.files
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.transform-icons
  .left
    transform: rotate(325deg)
  .center
    transform: rotate(358deg)
  .right
    transform: rotate(35deg)
</style>



// WEBPACK FOOTER //
// c_adjuntar_archivos.vue?4f2179c0